import React from 'react';

import Style from '../style.module.css';
import '../style.css';
import Star from '@images/star.svg';

import aircraftModelNameHelper from '@utils/aircraftModelNameHelper';
import { translate as t } from '@utils/translate';

const AircraftDescription = ({ aircraftDescription, avaliation }) => {
  const TEXTS = {
    SEATS: t('seats'),
    STAR: t('star'),
  };

  return (
    <div className={Style.aircraftDescription}>
      <p className={Style.aircraftSizeAndSeats}>
        {[
          aircraftDescription.model.aircraftSize.name,
          '·',
          aircraftDescription.quantityOfPassengers,
        ].join('  ')}{' '}
        <span>{TEXTS.SEATS}</span>
      </p>
      <div className={Style.modelContent}>
        <p className={Style.model}>{`${aircraftModelNameHelper(
          aircraftDescription.model
        )}`}</p>
        <img src={Star} alt={TEXTS.STAR} className={Style.star} />
        <p className={Style.aircraftStar}>{avaliation}</p>
      </div>
    </div>
  );
};

export default AircraftDescription;
